<template>
<div></div>
</template>

<script>
import {
  mapGetters,
  mapActions,
} from 'vuex';

export default {
  data() {
    return {
      audios: [], // only one voice line should play at a time, but several sfx could be playing
      lastVoiceLine: null, // reference to currently playing (or already ended) voice line, for interrupting
      voiceLineQueue: [], // for not interrupting
      lastVoiceLineFromTooltip: false,
      waitingTooltipVoiceLine: null,
      enableWarningOnPlayFailure: false,
      voicePlayFailureCount: 0,
    };
  },
  computed: {
    ...mapGetters([
      'muteVoices',
      'volumeVoices',
      'muteSFX',
      'volumeSFX',
      'sound',
      'soundSubmitter',
      'soundRequestClearAll',
      'soundNext',
      'soundIsVoice',
      'soundShouldQueue',
      'soundFromTooltip',
      'soundRequestClearLastTooltipVoice',
    ]),
  },
  watch: {
    soundSubmitter() {
      // this watcher triggers playing the sound
      // console.log(this.soundRequestClearAll);
      if (this.soundRequestClearAll) {
        if (this.lastVoiceLine) this.lastVoiceLine.pause();
        this.audios.forEach((audio) => {
          audio.pause();
          try {
            audio.src = null;
          } catch (er) {
            console.error(er);
          }
        });
        this.audios.length = 0;
        this.voiceLineQueue.length = 0;
        if (this.waitingTooltipVoiceLine) {
          this.waitingTooltipVoiceLine = null;
        }
      } else if (this.soundRequestClearLastTooltipVoice) {
        if (this.lastVoiceLineFromTooltip && this.lastVoiceLine && !(this.lastVoiceLine.ended)) {
          // clear currently-playing tooltip voice line
          this.lastVoiceLine.pause();
        }
        if (this.waitingTooltipVoiceLine) {
          this.waitingTooltipVoiceLine = null;
        }
      }

      if (this.sound) {
        // TODO: support local files with dynamically defined paths...? nothing seems to work.
        // console.log(this.sound);
        // let sound = this.sound;
        // if (this.sound.startsWith('./')) {
        //   sound = `../../../.${sound}`; // convert to src-relative path; WARNING: needs to be updated if this file is moved
        // }
        // const audio = new Audio(
        //   (this.sound.startsWith('.')) // local
        //     ? await import(sound)
        //     : this.resolveAssetPath(sound, 'audio')
        // );
        // audio.play();

        console.log(this.resolveAssetPath(this.sound || '', 'audio'));
        const nextSound = this.soundNext;
        const soundIsVoice = this.soundIsVoice;
        const audio =
          soundIsVoice
            ? (this.lastVoiceLine || this.voiceAudioFixer())
            : new Audio(this.resolveAssetPath(this.sound || '', 'audio')); // sfx creates new audios
        let playImmediately = true;
        if (soundIsVoice) {
          if (
            ((!(this.lastVoiceLineFromTooltip) && this.soundFromTooltip) || this.soundShouldQueue) // should not interrupt voice
            && this.lastVoiceLine && !(this.lastVoiceLine.ended) // voice is currently playing
          ) {
            // wait for voice line to end before playing this voice line.
            // note that if the line it's waiting on gets cancelled, it also gets implicitly cancelled.
            // right now that behavior is what we want.
            playImmediately = false;
            if (this.soundFromTooltip) {
              this.waitingTooltipVoiceLine = this.resolveAssetPath(this.sound || '', 'audio');
            } else {
              this.voiceLineQueue.push(this.resolveAssetPath(this.sound || '', 'audio'));
            }

            if (nextSound) {
              this.voiceLineQueue.push(this.resolveAssetPath(nextSound || '', 'audio'));
            }
          } else {
            // immediately cancel currently-playing voice line (and anything queued after it) so we can play this new voice line.
            if (this.lastVoiceLine) this.lastVoiceLine.pause();
            audio.src = this.resolveAssetPath(this.sound || '', 'audio');
            this.lastVoiceLineFromTooltip = this.soundFromTooltip;
            this.waitingTooltipVoiceLine = null;
            this.voiceLineQueue.length = 0;
            if (nextSound) {
              // using unshift to cut in front of the line because this should play immediately after
              this.voiceLineQueue.unshift(this.resolveAssetPath(nextSound || '', 'audio'));
            }
          }
        } else {
          audio.volume = Math.max(0, Math.min(1, (this.muteSFX ? 0 : ((this.volumeSFX / 100.0) + 1.0))));
          audio.addEventListener('ended', () => {
            if (nextSound) { // audio pairs that are to be played one after the other
              const nextAudio = new Audio(this.resolveAssetPath(nextSound || '', 'audio'));
              nextAudio.volume = Math.max(0, Math.min(1, (this.muteSFX ? 0 : ((this.volumeSFX / 100.0) + 1.0))));
              this.audios.push(nextAudio);
              nextAudio.play();
            }
            const index = this.audios.indexOf(audio);
            if (index >= 0) {
              this.audios.splice(index, 1);
            }
          });
          if (playImmediately) {
            this.audios.push(audio);
          }
        }

        console.log(audio.src);

        if (playImmediately) {
          console.log('play now');
          audio.play();
        } else {
          console.log('queued to play later');
        }
      }
    },
    muteVoices(newValue) {
      if (this.lastVoiceLine) {
        if (newValue) this.lastVoiceLine.volume = 0;
        else this.lastVoiceLine.volume = Math.max(0, Math.min(1, (this.volumeVoices / 100.0) + 1.0));
      }
    },
    volumeVoices(newValue) {
      if (this.lastVoiceLine) {
        this.lastVoiceLine.volume = Math.max(0, Math.min(1, (this.muteVoices ? 0 : ((newValue / 100.0) + 1.0))));
      }
    },
  },
  methods: {
    ...mapActions([
      'flashWarning',
    ]),
    voiceAudioFixer() { // necessary to do it this way to get voice lines to work on iOS
      if (!(this.lastVoiceLine)) {
        this.lastVoiceLine = new Audio('data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA');
        this.lastVoiceLine.volume = Math.max(0, Math.min(1, (this.muteVoices ? 0 : ((this.volumeVoices / 100.0) + 1.0))));
        this.lastVoiceLine.addEventListener('ended', async() => {
          if (this.voiceLineQueue.length) { // waiting primary voice line(s)
            const nextAudio = this.voiceLineQueue.shift(); // fifo
            this.lastVoiceLine.src = nextAudio;
            this.lastVoiceLineFromTooltip = false;
            await new Promise(resolve => setTimeout(resolve, 500)); // short delay between queued voice lines
            this.lastVoiceLine.play();
          } else if (this.waitingTooltipVoiceLine) { // waiting tooltip voice line
            this.lastVoiceLine.src = this.waitingTooltipVoiceLine;
            this.lastVoiceLineFromTooltip = true;
            await new Promise(resolve => setTimeout(resolve, 500)); // short delay between queued voice lines
            this.lastVoiceLine.play();
            this.waitingTooltipVoiceLine = null;
          }
        });
      }
      if (!(this.lastVoiceLine.ended)) {
        this.lastVoiceLine.play()
          .then(() => {
            window.removeEventListener('click', this.voiceAudioFixer);
          })
          .catch(() => {
            this.voicePlayFailureCount += 1;
            const message = 'Audio was unable to play. Check your browser settings for "prevent autoplay".';
            if (this.enableWarningOnPlayFailure && this.voicePlayFailureCount > 1 && this.voicePlayFailureCount < 3) {
              this.flashWarning({ message });
            } else {
              console.log(message);
            }
          });
      }
      return this.lastVoiceLine;
    },
  },
  mounted() {
    window.addEventListener('click', this.voiceAudioFixer);
    this.enableWarningOnPlayFailure = false;
    this.voicePlayFailureCount = 0;
    setTimeout(() => {
      this.enableWarningOnPlayFailure = true;
    }, 5000);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/game/pages/components/SoundManager.vue